import MindMap from './service/mindmap';
import Node from './service/node';
import Relation from './service/relation';

export default {
  MindMap,
  Node,
  Relation
};
